<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar flat>
                    <v-toolbar-title>{{ game.title }}</v-toolbar-title>

                    <v-spacer/>

                    <game-menu :game="game"/>
                </v-toolbar>

                <v-card flat tile min-height="500px" v-if="game.graveyardInvestigatorSessions">
                    <v-card-title>Defeated</v-card-title>
                    <v-card-text>
                        <v-row>
                            <template v-for="(from, fromIndex) in game.graveyardInvestigatorSessions">
                                <v-col :key="'graveyard' + fromIndex"
                                       cols="12"
                                       sm="6"
                                       md="4">
                                    <investigator :investigator-session="from"
                                                  :investigator-session-index="fromIndex"
                                                  :game="game"
                                                  @giveTo="giveTo"
                                                  @deleteInvestigator="deleteInvestigator"/>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card flat tile min-height="500px" v-if="game.devouredInvestigatorSessions">
                    <v-card-title>Out of game</v-card-title>
                    <v-card-text>
                        <v-row>
                            <template v-for="(investigatorSession, investigatorSessionIndex) in game.devouredInvestigatorSessions">
                                <v-col :key="'devoured' + investigatorSessionIndex"
                                       cols="12"
                                       sm="6"
                                       md="4">
                                    <investigator :investigator-session="investigatorSession"
                                                  :investigator-session-index="investigatorSessionIndex"
                                                  :game="game"
                                                  @deleteInvestigator="restoreInvestigator"/>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import GameService from "../services/GameService";
  import InvestigatorSessionService from "../services/InvestigatorSessionService";
  import GameMenu from "./GameMenu";
  import Investigator from "./Investigator";

  export default {
    components: {
      GameMenu,
      Investigator
    },

    computed: {
      game() {
        return this.$store.getters.game;
      }
    },

    created() {
      this.viewGame();
    },

    methods: {
      viewGame() {
        GameService.view(this.$route.params.gameId)
          .then(response => {
            this.$store.dispatch("setGameId", response.data.data.id);
            this.$store.dispatch("setGame", response.data.data);
          })
          .catch(() => {
            this.$router.push({name: "home"});
          });
      },

      giveTo(fromId, toId) {
        let from = this.game.graveyardInvestigatorSessions[fromId];
        let to = this.game.activeInvestigatorSessions[toId];

        if (confirm(`Are you sure you want to give the possessions of ${from.title} to ${to.title}?`)) {
          InvestigatorSessionService.moveToInvestigatorAndDestroy(from.id, to.id)
            .then(() => {
              this.viewGame();
            });
        }
      },

      deleteInvestigator(investigatorSession) {
        if (confirm(`Are you sure you want to remove ${investigatorSession.investigator.title} from the game?`)) {
          InvestigatorSessionService.delete(investigatorSession.id)
            .then(() => {
              this.viewGame();
            });
        }
      },

      restoreInvestigator(investigatorSession) {
        if (confirm(`Are you sure you want to restore ${investigatorSession.investigator.title} to the available investigators of the game?`)) {
          InvestigatorSessionService.restore(investigatorSession.id)
            .then(() => {
              this.viewGame();
            });
        }
      }
    }
  };
</script>
